<template >
    <aside class="most-top-banner animation show-display">
        <!-- <div class="container container--top">
            <p class="banner__left">
                <router-link :to="utmURL">
                    <strong class="mobile-none"><em class="strong--color">대량 견적문의</em>만 하면! <em class="strong--color">스타벅스 커피 쿠폰</em> 증정</strong>
                    <strong class="mobile-only"><em class="strong--color">대량 견적문의</em>만 하면! <br><em class="strong--color">스타벅스 커피 쿠폰</em> 선착순 100명</strong>
                </router-link>
            </p>
            <p class="banner__right">
                <router-link :to="utmURL" class="mr-auto mobile-none"><strong>선착순 100명 증정!!!</strong></router-link>
                <button type="button" @click="closeMostTopBanner(false)" class="btn--close">
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 1.91357L17.0864 0L9.5 7.58643L1.91357 0L0 1.91357L7.58643 9.5L0 17.0864L1.91357 19L9.5 11.4136L17.0864 19L19 17.0864L11.4136 9.5L19 1.91357Z" fill="#FFFFFF"/>
                    </svg>
                </button>
            </p>
        </div> -->
    </aside>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
export default {
    date() {
        return{
        }
    },
    
    computed: {
        ...mapState({
            vuexIsVisibleMostTopBanner: state => state.alarmStore.vuexIsVisibleMostTopBanner,
        }),
        
        utmURL(){
            const baseUrl = 'event';
            let utm = '';

            switch (this.$route.name) {
                case 'home':
                case 'explore':
                    utm = 'utm_source=yescon&utm_medium=yescon_main_upper_banner&utm_campaign=yescon_bulk_estimate_event_upper_banner';
                    break;
                case 'estimate':
                    utm = 'utm_source=yescon&utm_medium=yescon_estimate_upper_banner&utm_campaign=yescon_bulk_estimate_event_estimate_upper_banner';
                    break;
                case 'bulk-buying':
                case 'bulk-buying-benefit': 
                    utm = 'utm_source=yescon&utm_medium=yescon_bulk_estimate_upper_banner&utm_campaign=yescon_bulk_estimate_event_bulk_estimate_upper_banner';
                    break;
            }
            return `${baseUrl}?${utm}`;
        }
    },

    methods: {
        ...mapMutations({
            closeMostTopBanner: 'alarmStore/setVuexIsVisibleMostTopBanner'
        })
    }
}
</script>

<style lang="scss" scoped>
$banner-height: 60px;
$primary-color: #005a41;
$secondary-color: #ffd740;
$mini-device: 350px;

.most-top-banner {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    height: $banner-height;
    word-break: keep-all;

    &::before {
        content: '';
        flex: 1;
        background-color: $primary-color;
        // padding-right: var(--navbar-width);
    }
    &::after {
        content: '';
        flex: 1;
        background-color: $secondary-color;
    }

    .container--top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        color: var(--white);
        background-color: $primary-color;
        padding: 0;

        @media (min-width: 768px) {
            font-size: 18px;
        }

        @media (min-width: 1200px) {
            font-size: 20px;
        }

        @media (max-width: $mini-device) {
            font-size: 15px;
        }
    }
    .banner__left {
        padding-left: var(--container-padding);
    }
    .banner__right {
        padding-right: var(--container-padding);
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: $primary-color;
        background-color: $secondary-color;
        height: 100%;

        @media (min-width: 768px) {
            width: 40%;
        }

        &::before {
            content: '';
            border-left: 25px solid $primary-color;
            border-bottom: $banner-height solid $secondary-color;
            height: 100%;

            @media (min-width: 768px) {
                padding-left: var(--container-padding);
            }
        }
    }

    .strong--color{
        font-style: normal;
        color: $secondary-color;
        font-weight: 600;
    }

    .btn--close{
        display: inline-flex;
        height: 100%;
        align-items: center;

        @media (max-width: $mini-device) {
            font-size: 14px;
            letter-spacing: -1px;
            svg {
                width: 15px;
            }
        }
    }
}

.mr-auto{
    margin-right: auto;
}

.animation {
    transition: .35s;
    transform: translateY(100%);

    &.show-display {
        transform: translateY(0%);
    }
}
</style>